<div class="panel-header">
  <label>Data Entry Panel</label>
</div>
<div class="data-entry-form" [class.hidden]="!panelOpen">
  <ng-container *ngFor="let attribute of attributes">
    <div class="form-group">
      <ng-container *ngIf="IsCheckbox(attribute)">
        <div class="form-check form-group" [class.hidden]="!IsAvailable(attribute)"
          [class.changed]="IsChanged(attribute.id)">
          <div class="form-check-label" [innerText]="attribute.label"></div>
          <input [ngModel]="GetValue(attribute)" (change)="SetValue(attribute,$any($event.type).value,true)"
            type="checkbox" class="form-check">
        </div>
      </ng-container>
      <ng-container *ngIf="IsSelector(attribute)">
        <div class="form-group" [class.hidden]="!IsAvailable(attribute)" [class.changed]="IsChanged(attribute.id)">
          <div class="form-label" [innerText]="attribute.label"></div>
          <select [ngModel]="GetValue(attribute)" (change)="SetValue(attribute,$any($event.target).value,true)"
            class="form-select" *ngIf="attribute.options">
            <option *ngFor="let option of attribute.options" value="{{option.id}}">{{option.label}}</option>
          </select>
        </div>
      </ng-container>
      <ng-container *ngIf="IsInput(attribute)">
        <div class="form-group" [class.hidden]="!IsAvailable(attribute)" [class.changed]="IsChanged(attribute.id)">
          <div class="form-label" [innerText]="attribute.label"></div>
          <input type="text" [ngModel]="GetValue(attribute)"
            (change)="SetValue(attribute,$any($event.target).value,true)" class="form-control" />
        </div>
      </ng-container>
      <ng-container *ngIf="IsQty(attribute)">
        <div class="form-group" [class.hidden]="!IsAvailable(attribute)" [class.changed]="IsChanged(attribute.id)">
          <div class="form-label" [innerText]="attribute.label"></div>
          <input type="text" [ngModel]="GetValue(attribute)"
            (change)="SetValue(attribute,$any($event.target).value,true)" class="form-control" />
        </div>
      </ng-container>

    </div>
  </ng-container>
</div>
<div class="footer">
  <button [class.hidden]="!HasChanges()" (click)="UpdateFeature()"
    class="btn btn-text btn-primary btn-md"><span>Continue</span></button>
</div>
